import React from "react";
import {
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import ScrollToTop from "common/ScrollToTop";
import NotFoundPage from "pages/404";
import KosmofiLanding from "pages/Kosmofi/Landing";
import LandingPage from "../pages/LandingPage";
import AILandingPage from "../pages/AILandingPage";
import Careers from "../pages/Careers";
import FAQ from "../pages/Faq";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import About from "../pages/About";
import Legal from "../pages/Legal";
import Support from "../pages/Support";
import Ambassador from "../pages/Ambassador";
import Comparison from "../pages/Comparison";
import Boost from "../pages/Boost/TomoBoost";
import BoostAutoLoan from "../pages/Boost/components/LandingVariants/TomoBoostAutoLoan";
import BoostDispute from "../pages/Boost/components/LandingVariants/TomoBoostDispute";
import BoostCounseling from "../pages/Boost/components/LandingVariants/TomoBoostCounseling";
import BoostBusiness from "../pages/Boost/components/LandingVariants/TomoBoostBusiness";
import BoostFAQ from "../pages/BoostFaq";
import BoostBlog from "../pages/BoostBlog";
import BoostPricing from "../pages/Boost/BoostPricing";
import BoostCheckoutChargebee from "../pages/Boost/BoostCheckoutChargebee";
import ApplicationTroubleshooting from "../pages/ApplicationTroubleshooting";
import EmailVerificationRedirect from "../pages/EmailVerification";
// import AppRedirect from "../pages/AppRedirect";
import AppRedirectV2 from "../pages/AppRedirectV2";
import HowItWorks from "../pages/Boost/HowItWorks";
import ChargeBeePaymentMethod from "../pages/ChargeBeePaymentMethod";
import IQLanding from "../pages/IQ/Landing";

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route
          sensitive
          path="/:anything*([A-Z]):anything*/"
          render={(props) => (
            <Redirect to={`${props.location.pathname.toLowerCase()}`} />
          )}
        />
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/about" component={About} />
        {/* <Route exact path="/app" component={AppRedirect} /> */}
        <Route exact path="/app" component={AppRedirectV2} />
        <Route exact path="/boost" component={Boost} />
        <Route exact path="/boost/auto" component={BoostAutoLoan} />
        <Route exact path="/boost/dispute" component={BoostDispute} />
        <Route exact path="/cbpm" component={ChargeBeePaymentMethod} />
        <Route exact path="/boost/counseling" component={BoostCounseling} />
        <Route exact path="/boost-how-it-works" component={HowItWorks} />
        <Route exact path="/boost/business" component={BoostBusiness} />
        <Route exact path="/boost/small-business" component={KosmofiLanding} />
        <Route exact path="/boost-faq" component={BoostFAQ} />
        <Route exact path="/boost-pricing" component={BoostPricing} />
        <Route exact path="/boost-checkout" component={BoostPricing} />
        <Route exact path="/boost-checkout-new" component={BoostCheckoutChargebee} />
        <Route exact path="/boost-blog" component={BoostBlog} />
        <Route exact path="/boost/ai/:platform?" component={IQLanding} />
        <Route exact path="/careers" component={Careers} />
        <Route exact path="/faq" component={FAQ} />
        <Route exact path="/privacypolicy" component={PrivacyPolicy} />
        <Route exact path="/ai" component={AILandingPage} />
        <Route exact path="/legal" component={Legal} />
        <Route exact path="/support" component={Support} />
        <Route exact path="/ambassador" component={Ambassador} />
        <Route exact path="/thecard" component={Comparison} />
        <Route
          exact
          path="/application-troubleshooting"
          component={ApplicationTroubleshooting}
        />
        <Route exact path="/verification/email/check_v3" component={EmailVerificationRedirect} />
        <Route component={NotFoundPage} />
      </Switch>
    </>
  );
};

export default AppRoutes;